export default function validate(values, props) {
    const errors = {}
    const { messages } = props

    if (!values.email || !values.email.trim()) {
        errors.email = messages.errors.required({})
    } else if (!values.email.includes('@') || !values.email.includes('.')) {
        errors.email = messages.errors.invalid({ field: messages.loginForm.logonId() })
    } else if (!values.externalOrderId || !values.email.trim()) {
        errors.externalOrderId = messages.errors.required({})
    } else if (values.externalOrderId.length < 5) {
        errors.externalOrderId = messages.errors.minLength({ characters: '5' })
    }

    return errors
}
